import { queryOptions } from "@tanstack/react-query";

import { getMyCoachWheelFn } from "~/lib/functions/coach-wheel";

export const myCoachWheelQueryKey = ["coach-wheel", "mine"] as const;

export function myCoachWheelQueryOptions() {
  return queryOptions({
    queryKey: myCoachWheelQueryKey,
    queryFn: () => getMyCoachWheelFn(),
  });
}
